const TOKEN_KEY = 'authenticated'

/**
 * TokenService is deprecated for security: do NOT persist access tokens.
 * - getToken(): always returns null
 * - saveToken(): no-op and removes legacy key
 * - removeToken(): cleans up legacy key
 */
const TokenService = {
  getToken() {
    return null
  },

  saveToken(/* accessToken */) {
    try {
      localStorage.removeItem(TOKEN_KEY)
    } catch {}
    console.warn(
      'TokenService.saveToken is disabled: tokens are not stored in localStorage'
    )
  },

  removeToken() {
    try {
      localStorage.removeItem(TOKEN_KEY)
    } catch {}
  }
}

const StorageService = {
  getUseSSO() {
    return JSON.parse(localStorage.getItem('USE_SSO'))
  },
  saveUseSSO(useSSO) {
    localStorage.setItem('USE_SSO', JSON.stringify(useSSO))
  },
  getTaskId() {
    return localStorage.getItem('taskId')
  },
  saveTaskId(taskId) {
    localStorage.setItem('taskId', taskId)
  },
  getOrg() {
    return localStorage.getItem('org')
  },
  saveOrg(org) {
    localStorage.setItem('org', org)
  },
  getGlobalTask() {
    return localStorage.getItem('globalTask')
  },
  saveGlobalTask(globalTask) {
    localStorage.setItem('globalTask', globalTask)
  },
  getLanguage() {
    return localStorage.getItem('locale')
  },
  saveLanguage(locale) {
    localStorage.setItem('locale', locale)
  },
  saveTowerUser(user) {
    localStorage.setItem('tower_user', user)
  },
  getTowerUser() {
    return localStorage.getItem('tower_user')
  },
  saveTowerPassword(password) {
    // WARNING: Storing passwords in localStorage is a security risk
    console.warn(
      'Storing password in localStorage - consider using secure storage'
    )
    localStorage.setItem('tower_password', password)
  },
  getTowerPassword() {
    console.warn(
      'Retrieving password from localStorage - consider using secure storage'
    )
    return localStorage.getItem('tower_password')
  },
  saveTowerToken(token) {
    localStorage.setItem('tower_token', token)
  },
  getTowerToken() {
    return localStorage.getItem('tower_token')
  }
}

export { TokenService, StorageService }
